// The Auth0 callback (redirect_uri = origin + "/account"): finish the redirect,
// bind the device token through the gateway, then go where the person was headed.
import { IonContent, IonPage } from "@ionic/react";
import { useEffect, useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { handleRedirectCallback, isRedirectCallback } from "../auth/auth";
import { useMe } from "../api/live";
import { fixtureMode } from "../api/mode";
import { SignInPage } from "./SignInPage";

export function AccountPage() {
  const history = useHistory();
  const { reload, status } = useMe();
  const [error, setError] = useState<string | null>(null);
  const callback = typeof window !== "undefined" && isRedirectCallback(window.location.href);

  useEffect(() => {
    if (fixtureMode() || !callback) return;
    let live = true;
    handleRedirectCallback().then(
      (to) => { if (live) { reload(); history.replace(to); } },
      (e: { error?: string; message?: string }) => {
        // A reloaded callback has no transaction left: just sign in again.
        if (live) setError(e?.error === "missing_transaction" ? null : e?.message ?? "Sign-in didn't finish.");
      }
    );
    return () => { live = false; };
  }, [callback, history, reload]);

  if (fixtureMode() || (!callback && status === "in")) return <Redirect to="/week" />;
  if (!callback) return <SignInPage returnTo="/week" />;
  return (
    <IonPage>
      <IonContent>
        <div className="signin">
          <div className="card">
            <h1>{error ? "Sign-in didn't finish" : "Signing you in…"}</h1>
            <p>{error ?? "Checking your account with OnlyCat."}</p>
            {error ? <a className="btn btn--primary btn--lg" href="/week">Try again</a> : null}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
